


























































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ImageInfo from '@/views/AiiTasks/ImageInfo.vue'
import MediateInfo from '@/views/mediate/mediateInfo.vue'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import { uuid, dateFormat, throttle, download } from '@/utils/util'
import RelationOrders from '@/views/AiiTasks/RelationOrders.vue'
import Task from '@/web-task'
import Info from '@/views/AiiTasks/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import ImageItem from '@/views/AiiTasks/ImageItem.vue'
import ImageList from '@/views/AiiTasks/ImageList.vue'
import StaffInfo from '@/components/task/StaffInfo.vue'
import CancelApply from '@/components/task/CancelApply.vue'
import RecordSection from '@/components/task/RecordSection.vue'
import MediateCost from '@/views/mediate/mediateCost.vue'
import MediateApi from '@/api/mediate'
import Viewer from 'viewerjs'
import { hasValue } from '@/utils/util'
import { ORDER_STATUS_DICT } from '@/web-task/config.ts'
import bus from '@/views/AiiTasks/bus'
import 'viewerjs/dist/viewer.css'
let viewer: any = ''

@Component({
	components: {
		ImageInfo,
		MediateInfo,
		RelationOrders,
		Info,
		InfoRow,
		ImageItem,
		ImageList,
		StaffInfo,
		CancelApply,
		MediateCost,
		RecordSection,
	},
})
export default class MediateTabs extends Vue {
	@Prop()
	public task!: any

	@Prop()
	public injured!: any

	@Prop()
	public order!: any

	@Prop()
	public orderId!: string

	@Prop()
	private show!: any

	@Prop()
	private changingCost!: boolean

	@Prop()
	private confirmBoxVisible!: boolean

	@Prop()
	private activeKey!: any

	private taskInfo: any = []
	private staffInfo: any = []
	private operatorCancelReasonInfo: any = false
	private operatorCancelHistoryInfo: any = false
	private carOwnerInfo: any = []
	private injuredInfo: any = []
	private costTableInfo: any = []
	private caseDelayInfo: any = {}
	private confirmForm: any = {}
	private costForm: any = {}
	private YI_WAN_CHENG_WEI_TIAO_JIE =
		ORDER_STATUS_DICT.YI_WAN_CHENG_WEI_TIAO_JIE
	private YI_WAN_CHENG_TIAO_JIE_SHI_BAI =
		ORDER_STATUS_DICT.YI_WAN_CHENG_TIAO_JIE_SHI_BAI
	private YI_WAN_CHENG_TIAO_JIE_CHENG_GONG =
		ORDER_STATUS_DICT.YI_WAN_CHENG_TIAO_JIE_CHENG_GONG

	private get recordInfoMap() {
		const obj: any = {}
		if (this.injured.mediaInfoList && this.injured.mediaInfoList.length) {
			for (const i of this.injured.mediaInfoList) {
				if (!obj[i.type]) {
					obj[i.type] = []
				}
				obj[i.type].push(i)
			}
		}

		return obj
	}

	// 无需调解的伤者列表下标
	private get noMediateIndex() {
		let indexArr: number[] = []
		if (!(this.order.orderStatus === '04' && this.order.auditOperationTime)) {
			let injuredArr = this.injured && this.injured.injuredList
			if (injuredArr) {
				injuredArr.forEach((item: any, index: number) => {
					if (item.agreement && item.agreement.conciliationStatus === '0') {
						indexArr.push(index)
					}
				})
			}
		}
		return indexArr
	}

	private get firstMediateInjured() {
		return this.injuredInfo.findIndex((item: any, index: number) => {
			return !this.noMediateIndex.includes(index)
		})
	}

	@Watch('task', { immediate: true })
	private onTaskChange() {
		// task为{}，非Task对象时不调用属性方法
		if (!(this.task instanceof Task)) {
			return
		}
		this.$emit('setChangingCost', false)
		this.taskInfo = this.task.getTaskInfo()

		this.staffInfo = this.task.getStaffInfo()

		this.operatorCancelReasonInfo = this.task.getOperatorCancelReasonInfo()

		this.operatorCancelHistoryInfo = this.task.getOperatorCancelHistoryInfo()
		this.carOwnerInfo = this.task.getMediateCarOwner()
		this.injuredInfo = this.task.getMediateInjured()
		this.costTableInfo = this.task.getCostTableInfo()
		this.caseDelayInfo = this.task.getCaseDelayInfo()
	}

	private get supplyInfo() {
		if (['01', '02', '03'].includes(this.order.orderStatus)) {
			if (this.order.returnFlag === '1') {
				return '（待作业人员重新补录）'
			}
			return '（待作业人员补录）'
		}
		return ''
	}

	@Watch('activeKey')
	private onTabsChange() {
		window.scrollTo(0, 0)
	}

	private setChangingCost(status: boolean) {
		this.$emit('setChangingCost', status)
	}

	private getDetail() {
		this.$emit('getDetail')
	}

	private hiddenConfirmBox() {
		this.$emit('hiddenConfirmBox', false)
	}

	private hiddenCostBox() {
		this.$emit('setChangingCost', false)
	}

	private zeroUnit(val: any, unit: string = '元') {
		if (val === 0 || val) {
			return val + unit
		} else {
			return
		}
	}

	private keepNumber(str: string) {
		let temp = str.match(/-?\d+/)
		if (temp) {
			return str.slice(temp.index)
		} else {
			return ''
		}
	}

	// 待确认-确认通过
	private auditConciliationAgreement() {
		this.confirmForm.validateFields((err: any, values: any) => {
			if (!err) {
				let data: any = []
				values.conciliationList.forEach((item: any, index: number) => {
					if (item) {
						let temp = cloneDeep(item),
							costTable = this.costTableInfo[index]
						temp.id = costTable[0].agreementId
						data.push(temp)
					}
				})
				MediateApi.auditConciliationAgreement({
					orderId: this.$route.params.orderId,
					pass: '1',
					conciliationList: data,
				}).then(() => {
					this.$emit('getDetail')
					this.hiddenConfirmBox()
					bus.$emit('showEvaluate')
				})
			}
		})
	}

	private confirmChange() {
		// 提交修改的金额
		this.costForm.validateFields((err: any, values: any) => {
			if (!err) {
				let data = cloneDeep(values),
					fees = [],
					notSetIndex = -1
				const fields = [
					'medicalFee',
					'furtherMedicalFee',
					'mealsFee',
					'compensation',
					'caregiversFee',
					'commuteFee',
					'otherFee',
				]
				for (let index = 0; index < data.fees.length; index++) {
					let item = data.fees[index]
					if (!item) {
						continue
					}
					const some = fields.some((key: any) => {
						return hasValue(item[key])
					})
					item.injuredId = this.injuredInfo[index].injuredId
					item.id = this.injuredInfo[index].agreementId
					fees.push(item)
					if (!some && notSetIndex < 0) {
						notSetIndex = index
					}
				}
				data.fees = fees
				// 至少需填写一项费用
				if (notSetIndex >= 0) {
					this.$message.error(
						`请填写需要赔付给${this.injuredInfo[notSetIndex].injuredName}的对应的费用，最少填写一项`
					)
					return
				}
				MediateApi.updateConciliationAgreementAmount({
					orderId: this.$route.params.orderId,
					create: '1',
					fees: data.fees,
				}).then(() => {
					this.$emit('getDetail')
					this.$emit('setChangingCost', false)
				})
			}
		})
	}

	private dateFormat(start: any, end: any) {
		return dateFormat(start, end)
	}

	private created() {
		this.confirmForm = this.$form.createForm(this)
		this.costForm = this.$form.createForm(this)
	}
}
